import { TextField } from '@lifeomic/chroma-react/components/TextField';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { Filter } from '../../types';
import { TextEntryFilterOption } from '../options/types';
import { BaseFilterComponent } from './types';

export const getChromosomeNumber = (value: string) => {
  const [chromosomeValue] = value.split(':');
  const [_, chromosomeNumber] = chromosomeValue.split('chr');
  return chromosomeNumber || chromosomeValue;
};

export const getPositionValue = (value: any) => {
  const [, positionValue] = value.split(':');
  return positionValue;
};

const getChromosomeFilter = ({
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  id, // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  number, // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  origin,
}) => {
  const chromosomeValue = `chr${number}`;

  return {
    id: `${id}+${chromosomeValue.toLowerCase()}`,
    friendlyName: `Chromosome ${number}`,
    origin,
    searchKey: 'chromosome',
    searchValue: chromosomeValue,
  };
};

const getPositionFilter = ({
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  id, // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  origin, // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  value,
}) => ({
  id: `${id}+${value.toLowerCase()}`,
  origin,
  searchKey: 'position',
  searchValue: value,
});

interface PositionTextEntryProps
  extends TextEntryFilterOption,
    BaseFilterComponent {}

export const PositionTextEntry: React.FC<PositionTextEntryProps> = ({
  injectedProps: { textEntryOption },
  onFilterAdd,
  origin,
}) => {
  const { formatMessage } = useIntl();

  const [textValue, setTextValue] = React.useState<string>('');

  const handleTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTextValue(e.target.value);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!textValue || textValue?.trim?.()?.length === 0) {
      return;
    }

    if (e.key !== 'Enter') {
      return;
    }

    if (onFilterAdd) {
      const chromosomeNumber = getChromosomeNumber(textValue);
      const positionValue = getPositionValue(textValue);

      if (!chromosomeNumber || (!chromosomeNumber && !positionValue)) {
        return;
      }

      const chromosomeFilter: Filter = getChromosomeFilter({
        // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
        id: textEntryOption.id,
        number: chromosomeNumber,
        origin,
      });

      if (positionValue) {
        const positionFilter: Filter = getPositionFilter({
          // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
          id: textEntryOption.id,
          origin,
          value: positionValue,
        });

        onFilterAdd([chromosomeFilter, positionFilter]);
      } else {
        onFilterAdd(chromosomeFilter);
      }
    }

    setTextValue('');
  };

  return (
    <TextField
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      placeholder={formatMessage(textEntryOption.placeholderIntlLabel)}
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      aria-label={formatMessage(textEntryOption.placeholderIntlLabel)}
      value={textValue}
      onChange={handleTextFieldChange}
      onKeyPress={handleKeyPress}
      fullWidth
    />
  );
};
